// frontend/src/hooks/useKeyboardSave.js
// Intercepts Ctrl+S / Cmd+S and calls the provided save handler.

import { useEffect } from 'react';

export default function useKeyboardSave(saveHandler, hasChanges) {
  useEffect(() => {
    const handler = (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key === 's') {
        e.preventDefault();
        if (hasChanges && saveHandler) {
          saveHandler();
        }
      }
    };
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [saveHandler, hasChanges]);
}
